import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .directive('bringozPpi', bringozPpi);

function bringozPpi() {
  return {
    restrict: 'A',
    link: (scope, elem, attr) => {
      // elem.addClass('smartlook-hide');
      attr.$set('data-sl', 'mask');
    }
  };
}
